/* eslint-disable */
import { Box, Button, Divider, Popover, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { connect } from "react-redux";
import moment from "moment";
import CollectedDataModal from "./CollectedDataModal";
import RequestModal from "./RequestModal";
import Statistics from "../Statistics";
import { getPresignedUrlView } from "../../utils/files";

const columnNames = [
  "amarant:colDate",
  "amarant:colTime",
  "amarant:colTitle",
  "amarant:colObject",
  "amarant:colCalculateOnly",
  "amarant:colRoom",
  "amarant:colAllCollectedData",
  "amarant:colRequest",
  "amarant:colError",
];

const fieldNames = [
  "createdAt",
  "createdAt",
  "platform",
  "requestData",
  "calculateOnly",
  "room",
];

function ErrorsComponent({
  errors,
  tableRef,
  totalPages,
  listErrors,
  customerID,
}) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  const [currentError, setCurrentError] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [nextPage, setNextPage] = useState(2);
  const [displayedErrors, setDisplayedErrors] = useState([]);
  const [openCollectedData, setOpenCollectedData] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const [innerLoading, setInnerLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const observer = useRef();
  const isLoadingRef = useRef(false);
  const nextPageRef = useRef(2);
  
  // Sync ref with state
  useEffect(() => {
    nextPageRef.current = nextPage;
  }, [nextPage]);
  
  const handleLoadErrorsRef = useCallback(
    (node) => {
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && nextPageRef.current <= totalPages && !isLoadingRef.current) {
          isLoadingRef.current = true;
          setInnerLoading(true);
          listErrors({
            customerSupportId: customerID,
            pageNumber: nextPageRef.current,
            onSuccess: (res) => {
              setInnerLoading(false);
              setDisplayedErrors(prev => [...prev, ...res.payload.errors]);
              setNextPage(prev => prev + 1);
              isLoadingRef.current = false;
              
              // Stop observing if no more pages
              if (nextPageRef.current + 1 > totalPages && observer.current) {
                observer.current.disconnect();
              }
            }
          });
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    },
    [totalPages, customerID, listErrors]
  );
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const fetchAndOpenPreSignedUrl = async (file) => {
    let url;
    if (file?.startsWith?.("https://rpa-stats.s3.eu-central-")) {
      url = file;
    } else {
      url = await getPresignedUrlView(file);
    }
    window.open(url);
  };

  // Initialize displayedErrors when errors prop changes (only on first load)
  useEffect(() => {
    if (errors && errors.length > 0 && displayedErrors.length === 0) {
      setDisplayedErrors(errors);
      setNextPage(2);
      nextPageRef.current = 2;
    }
  }, [errors, totalPages, displayedErrors.length]);

  // Cleanup observer on unmount
  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  return (
    <>
      <div className={styles["blurred-background"]} id="blurred">
        <div className={styles["errorModal"]}>
          <div className={styles["headerModal"]} style={{ width: "97%" }}>
            <b
              style={{
                textTransform: "uppercase",
                fontSize: "16px",
                marginLeft: window.innerWidth < 900 && "4%",
              }}
            >
              {t("amarant:request")}
            </b>
            <div
              className={styles["closeModal"]}
              onClick={() => {
                document.getElementById("blurred").style.display = "none";
              }}
            />
          </div>
          <div className={styles["bodyModal"]} style={{ border: "none" }}>
            <div className={styles["innerBox"]}>
              <p>{currentError?.error}</p>
            </div>
            <div
              className={styles["buttonContainer"]}
              style={{
                width: "95%",
                display: "flex",
                justifyContent: "center",
                marginTop: "4%",
              }}
            >
              <div
                className={styles["copyButton"]}
                onClick={(event) => {
                  navigator.clipboard.writeText(currentError?.error);
                  handleClick(event);
                }}
              >
                {t("amarant:copy")}
              </div>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => {
                  handleClose();
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                sx={{
                  height: "150px",
                }}
              >
                <Typography sx={{ padding: "10px" }}>
                  {t("amarant:copied")}
                </Typography>
              </Popover>
            </div>
          </div>
        </div>
      </div>
      {window.innerWidth < 900 ? (
        <>
          <div
            className={styles["tabs-container"]}
            style={{ overflowY: "scroll", padding: "0px", height: "100%" }}
            ref={tableRef}
          >
            {displayedErrors?.map((error, i) => {
              const isLastElement = i === displayedErrors.length - 1;
              return (
                <div
                  ref={isLastElement ? handleLoadErrorsRef : null}
                  className={styles["row-container"]}
                  style={{
                    marginTop: "5%",
                    display: "block",
                    height: "unset",
                    width: "100%",
                  }}
                  key={i}
                >
                  {fieldNames.map((field, j) => {
                    return (
                      <React.Fragment key={j}>
                        <div className={styles["mobile-box"]}>
                          <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {t(columnNames[j])}
                          </p>
                          <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {j === 0
                              ? moment(error[field]).format("DD.MM.YYYY")
                              : j === 1
                              ? moment(error[field]).format("HH:mm")
                              : j === 3
                              ? error[field]?.licensePlate
                              : error[field] === true
                              ? t("yes")
                              : error[field] === false
                              ? t("no")
                              : error[field]}
                          </b>
                        </div>
                        <Divider />
                      </React.Fragment>
                    );
                  })}
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      AllCollectedData
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      <div
                        style={{
                          display: "flex",
                          width: "30%",
                          marginTop: "1%",
                        }}
                        onClick={() => {
                          setCurrentError(error);
                          setOpenCollectedData(true);
                        }}
                      >
                        <b
                          style={{
                            textDecoration: "underline",
                            color: "#0DC1CE",
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                        >
                          {t("amarant:view")}
                        </b>
                        <div
                          className={styles["info-icon"]}
                          style={{ marginLeft: "2%", marginRight: "5%" }}
                        />
                      </div>
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t("amarant:colRequest")}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      <div
                        style={{
                          display: "flex",
                          width: "30%",
                          marginTop: "1%",
                        }}
                        onClick={() => {
                          setCurrentError(error);
                          setRequestModal(true);
                        }}
                      >
                        <b
                          style={{
                            textDecoration: "underline",
                            color: "#0DC1CE",
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                        >
                          {t("amarant:view")}
                        </b>
                        <div
                          className={styles["info-icon"]}
                          style={{ marginLeft: "2%", marginRight: "5%" }}
                        />
                      </div>
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t("amarant:colError")}
                    </p>
                    <b
                      style={{
                        marginBottom: "1%",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className={styles["errorLog"]}
                        onClick={() => {
                          setCurrentError(error);
                          document.getElementById("blurred").style.display =
                            "block";
                        }}
                      />
                      {error?.screenshot && (
                        <p
                          style={{
                            color: "#0DC1CE",
                            textDecoration: "underline",
                            cursor: "pointer",
                            marginLeft: "5%",
                          }}
                          onClick={() =>
                            fetchAndOpenPreSignedUrl(error?.screenshot)
                          }
                        >
                          {t("amarant:screenshot")}
                        </p>
                      )}
                    </b>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className={styles["columns-container"]}>
            <div className={styles["upper-names"]}>
              {columnNames.map((column, i) => {
                return (
                  <div
                    className={`${styles["name-icon"]}`}
                    style={{
                      width: i === 2 ? "11%" : "8.2%",
                      cursor: i <= 3 ? "pointer" : "default",
                    }}
                    key={i}
                    onClick={() => {
                      if (i > 3) return;

                      if (filter === "plate") {
                        setFilter("reverse");
                      } else {
                        setFilter("plate");
                      }
                    }}
                  >
                    <p>{t(column)}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className={styles["tabs-container"]}
            style={{ overflowY: "scroll", flex: 1 }}
            ref={tableRef}
          >
            {displayedErrors?.map((error, i) => {
              const isLastElement = i === displayedErrors.length - 1;
              return (
                <div
                  ref={isLastElement ? handleLoadErrorsRef : null}
                  className={styles["row-container"]}
                  style={{ width: "100%", minHeight: "50px", height: "auto" }}
                  key={i}
                >
                  <div className={styles["data"]}>
                    <b>{moment(error.createdAt).format("DD.MM.YYYY")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]}>
                    <b>{moment(error.createdAt).format("HH:mm")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "11%" }}>
                    <b>Error in {error.platform}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div
                    className={styles["data"]}
                    style={{
                      justifyContent: "space-between",
                      display: "flex",
                    }}
                  >
                    <b>{error.requestData.licensePlate}</b>
                    {/*  <div
                  className={styles["errorLog"]}
                  onClick={() => {
                    setCurrentError(error);
                    document.getElementById("blurred").style.display = "block";
                  }}
                />
                */}
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "7%" }}>
                    <b>{`${error?.calculateOnly}`}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "10%" }}>
                    <b
                      style={{ wordBreak: "break-word" }}
                    >{`${error?.room}`}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "8%" }}>
                    <p>{t("amarant:details")}</p>
                    <div
                      className={styles["info-icon"]}
                      onClick={() => {
                        setCurrentError(error);
                        setOpenCollectedData(true);
                      }}
                    />
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "8%" }}>
                    <p>{t("amarant:details")}</p>
                    <div
                      className={styles["info-icon"]}
                      onClick={() => {
                        setCurrentError(error);
                        setRequestModal(true);
                      }}
                    />
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />

                  <div className={styles["data"]} style={{ width: "8%" }}>
                    <div
                      className={styles["errorLog"]}
                      onClick={() => {
                        setCurrentError(error);
                        document.getElementById("blurred").style.display =
                          "block";
                      }}
                    />
                    {error?.screenshot && (
                      <p
                        style={{
                          color: "#0DC1CE",
                          textDecoration: "underline",
                          cursor: "pointer",
                          marginLeft: "5%",
                        }}
                        onClick={() =>
                          fetchAndOpenPreSignedUrl(error?.screenshot)
                        }
                      >
                        {t("amarant:screenshot")}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
            {innerLoading && (
              <div
                className="inner-loader-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Statistics.LoaderInline center />
              </div>
            )}
          </div>
        </>
      )}
      <CollectedDataModal
        open={openCollectedData}
        handleClose={() => setOpenCollectedData(false)}
        currentError={currentError}
        mobileModal={window.innerWidth < 900 && true}
      />
      <RequestModal
        open={requestModal}
        handleClose={() => setRequestModal(false)}
        data={currentError}
        mobileModal={window.innerWidth < 900 && true}
        fromError={true}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  fines: state.amarantFields.fines,
});

const mapDispatchToProps = (dispatch) => ({
  listFines: (payload) => dispatch(listFines(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorsComponent);
